import React from "react";
import { fmtINR, fmtNum } from "../../utils/formatters";
import { T } from "../../constants/theme";

/** Item sale row */
const ItemSaleRow = ({ item, type, loading }) => (
  <div className="sad-item-row">
    <div
      style={{
        width: "22px",
        height: "22px",
        borderRadius: "50%",
        flexShrink: 0,
        background: type === "most" ? "#e8f5e9" : "#fde8e8",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "11px",
        fontWeight: 700,
        color: type === "most" ? "#2e7d32" : T.red,
      }}
    >
      {item.rank}
    </div>
    <div style={{ flex: 1, minWidth: 0 }}>
      <div
        style={{
          fontSize: "12px",
          fontWeight: 600,
          color: T.text,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {item.item}
      </div>
      <span
        style={{
          fontSize: "10px",
          padding: "1px 5px",
          borderRadius: "10px",
          background: T.light,
          color: T.muted,
          fontWeight: 600,
        }}
      >
        {item.category}
      </span>
    </div>
    <div style={{ textAlign: "right", flexShrink: 0 }}>
      <div style={{ fontSize: "12px", fontWeight: 700, color: T.text }}>
        {loading ? "…" : `${fmtNum(item.qty)} units`}
      </div>
      <div style={{ fontSize: "11px", color: T.muted }}>{fmtINR(item.amount)}</div>
    </div>
  </div>
);

export default ItemSaleRow;
